import React, { useState } from 'react';

import SportOfficialsCreateForm from './SportOfficialsCreateForm';

import Button from 'CommonComponents/Button';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function SportOfficialsCreateModal(props) {
    const [sportOfficialIsUpdated, setSportOfficialIsUpdated] = useState(false);
    const [request, setRequest] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);

    const cleanStates = () => {
        setRequest(false);
        setRequestFailed(false);
        setSportOfficialIsUpdated(false);
    };

    const internalCloseHandler = () => {
        cleanStates();
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        cleanStates();
        props.successHandler();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t('Create Sport Official')} close={internalCloseHandler}></ModalHeader>
                    <div className="tw-rounded-b">
                        <div className="modal__form-container">
                            <div className={!sportOfficialIsUpdated && !requestFailed ? 'modal__form-container' : 'hidden'}>
                                <SportOfficialsCreateForm
                                    nationalities={props.nationalities}
                                    sportOfficialsStoreUrl={props.sportOfficialsStoreUrl}
                                    internalCloseHandler={internalCloseHandler}
                                    setSportOfficialIsUpdated={setSportOfficialIsUpdated}
                                    request={request}
                                    officialRole={props.officialRole}
                                />
                            </div>
                            <div className={sportOfficialIsUpdated ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                <label className="modal__msg modal__text-color">{$t('Official Created')}</label>
                            </div>
                            <div className={requestFailed ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                <label className="modal__msg modal__error-text-color">{$t('Official could not be created')}</label>
                            </div>

                            {(sportOfficialIsUpdated || requestFailed) && (
                                <div className="modal__footer">
                                    <Button variant="secondary" onClick={internalSuccessHandler}>
                                        {$t('Close')}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
